<template>
  <!--Componente para dar color a las condiciones de contrato-->
  <div>
    <strong :class="ClassObject" v-if="rowvalue === null">
      Sin Contrato
    </strong>
    <strong v-else :class="ClassObject">
      {{ rowvalue }}
    </strong>
  </div>
</template>

<script>
export default {
  name: "ContractConditioColors",
  props: {
    rowvalueId: {
      type: [String, Number],
      default: "",
      required: true
    },
    rowvalue: {
      type: String,
      default: "",
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  computed: {
    ClassObject() {
      let isred = false;
      let isblinking = false;
      let isgreen = false;

      switch (this.rowvalueId) {
        case 0:
          isgreen = true;

          break;
        case 1:
          isred = true;
          break;
        case 2:
          isred = true;
          isblinking = true;
          break;
        default:
          break;
      }

      return {
        red: isred,
        // yellow: isyellow,
        green: isgreen,
        blinking: isblinking
      };
    }
  },
  methods: {
    // handleClick(row, column, rowValue) {
    //   console.log("row:", row, "\ncolumn:", column, "\nrowValue:", rowValue);
    // },
  }
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.yellow {
  color: orange;
}
.green {
  color: green;
}
.blinking {
  animation: blink 1s steps(1) infinite;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
